export enum LocalStorageKeyEnum {
  FACTORYPAYERSPRELOAD = "factoryPayersPreload",
  TOGGLES = "toggles",
  UPDATEDTOGGLESDATE = "updatedTogglesDate",
}
